module.exports = __webpack_public_path__ + "img/infoIcon.6c902ef7.svg";